<ng-template #modalFFProbeJSON>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        FFProbe JSON
        @if (canRefreshFFProbe()) {
          <app-do-button #ffprobeRefreshBtn
            class="cl-a-quickaction"
            [messageField]="ffprobe_message"
            (actionTriggered)="refresh_ffprobe($event)" buttonClass="cl-btn-quickaction it-cancel">
            @if (ffprobeRefreshBtn._processing) {
              <i class="fas fa-spinner fa-spin" style="font-size: 0.75em; margin-right: 4px"></i>
            }
            <span>Refresh</span>
          </app-do-button>
        }
      </div>
      <div class="modal-body">
        <div class="pre-container">
          <pre>{{ ffprobe| json }}</pre>
          <app-do-button class="pre-copy-btn"
            [messageField]="ffprobe_message"
            (actionTriggered)="copy_ffprobe($event)" buttonClass="btn cl-btn-icon cl-color-tertiary it-cancel">
            <i class="fas fa-copy" aria-hidden="true"></i>
            <span class="sr-only">Copy ffprobe data</span>
          </app-do-button>
        </div>
      </div>
      <div class="modal-footer">
        <span class="modal-footer-left"></span>

        <span class="modal-footer-center">
          <div style="margin-top: -8px">
            <app-message-field #ffprobe_message/>
          </div>
        </span>
        <span class="modal-footer-right">
          <button type="button" class="btn cl-color-secondary it-ok"
                  (click)="dialog.closeAll()">
            <span>Close</span>
          </button>
        </span>
      </div>
    </div>
  </div>
</ng-template>



<ng-template #modalExtraInfo>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        Extra info
        @if (canRefreshExtra()) {
          <app-do-button #extraRefreshBtn buttonClass="cl-btn-quickaction it-cancel"
                          [messageField]="extrainfo_message"
                          (actionTriggered)="refresh_extra_info($event)"
          >
            @if (extraRefreshBtn._processing) {
              <i class="fas fa-spinner fa-spin" style="font-size: 0.75em; margin-right: 4px"></i>
            }
            <span>Refresh</span>
          </app-do-button>
        }
      </div>
      <div class="modal-body">
        <div class="pre-container">
          <pre>{{ extra_info | json }}</pre>
          <app-do-button class="pre-copy-btn"
            buttonClass="btn cl-btn-icon cl-color-tertiary it-cancel"
            [messageField]="extrainfo_message"
            (actionTriggered)="copy_extra_info($event)">
            <i class="fas fa-copy" aria-hidden="true"></i>
            <span class="sr-only">Copy extra info</span>
          </app-do-button>
        </div>
      </div>
      <div class="modal-footer">
            <span class="modal-footer-left"></span>
        <span class="modal-footer-center">
              <div style="margin-top: -8px">
                <app-message-field #extrainfo_message/>
              </div>
            </span>
        <span class="modal-footer-right">
              <button type="button" class="btn cl-color-secondary"
                      (click)="dialog.closeAll()">
                <span>Close</span>
              </button></span>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #modalMediaInfo>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        MediaInfo JSON
        @if (canRefreshMediaInfo()) {
          <app-do-button #mediaInfoJsonRefreshBtn [messageField]="mediainfo_json_message" buttonClass="cl-btn-quickaction"
                          (actionTriggered)="refresh_mediainfo($event)"
          >
            @if (mediaInfoJsonRefreshBtn._processing) {
              <i class="fas fa-spinner fa-spin" style="font-size: 0.75em; margin-right: 4px"></i>
            }
            <span>Refresh</span>
          </app-do-button>
        }
      </div>
      <div class="modal-body">
        <div class="pre-container">
          <pre>{{ mediainfo_json | json }}</pre>
          <app-do-button class="pre-copy-btn"
            [messageField]="mediainfo_json_message" buttonClass="btn cl-btn-icon cl-color-tertiary"
            (actionTriggered)="copy_mediainfo_json($event)">
            <i class="fas fa-copy" aria-hidden="true"></i>
            <span class="sr-only">Copy MediaInfo JSON</span>
          </app-do-button>
        </div>
      </div>
      <div class="modal-footer">
              <span class="modal-footer-left"></span>
        <span class="modal-footer-center">
                <div style="margin-top: -8px">
                  <app-message-field #mediainfo_json_message/>
                </div>
              </span>
        <span class="modal-footer-right">
                <button type="button" class="btn cl-color-secondary it-ok"
                        (click)="dialog.closeAll()">
                  <span>Close</span>
                </button></span>
      </div>
    </div>
  </div>

</ng-template>


<ng-template #modalMediaInfoTxt>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        MediaInfo text
        @if (canRefreshMediaInfo()) {
            <app-do-button #mediaInfoTxtRefreshBtn
              (actionTriggered)="refresh_mediainfo($event)" [messageField]="mediainfo_message"
              buttonClass="cl-btn-quickaction"
            >
              @if (mediaInfoTxtRefreshBtn._processing) {
                <i class="fas fa-spinner fa-spin" style="font-size: 0.75em; margin-right: 4px"></i>
              }
              <span>Refresh</span>
            </app-do-button>
          }
      </div>
      <div class="modal-body">
        <div class="pre-container">
          <pre>{{ mediainfo }}</pre>
          <app-do-button class="pre-copy-btn"
            [messageField]="mediainfo_message"
            buttonClass="btn cl-btn-icon cl-color-tertiary"
            (actionTriggered)="copy_mediainfo($event)">
            <i class="fas fa-copy" aria-hidden="true"></i>
            <span class="sr-only">Copy MediaInfo report</span>
          </app-do-button>
        </div>
      </div>
      <div class="modal-footer">
        <span class="modal-footer-left"></span>
        <span class="modal-footer-center">
                  <div style="margin-top: -8px">
                    <app-message-field #mediainfo_message/>
                  </div>
                </span>
        <span class="modal-footer-right">
                  <button type="button" class="btn cl-color-secondary"
                          (click)="dialog.closeAll()">
                    <span>Close</span>
                  </button></span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalWarningOccurrences>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        All occurrences ({{ warningOccurrences.length }})
      </div>
      <div class="modal-body" style="overflow: hidden">
        <div style="max-height: 60vh" data-simplebar>
          @for (item of warningOccurrences; track $index) {
            <div class="basic-qc-occurrence">
              @if (hasKeys(item.details, 'start', 'end', 'text')) {
                <code class="basic-qc-ts">{{ item.details.start }}</code>
                &nbsp;—&nbsp;
                <code class="basic-qc-ts">{{ item.details.end }}</code>
                &nbsp;"{{ item.details.text }}"
              } @else if (item.details) {
                <pre class="basic-qc-unknown">{{ item.details | json }}</pre>
              } @else {
                <pre class="basic-qc-unknown">{{ item | json }}</pre>
              }
            </div>
          }
        </div>
      </div>
      <div class="modal-footer">
        <span class="modal-footer-left"></span>
        <span class="modal-footer-center"></span>
        <span class="modal-footer-right">
          <button type="button" class="btn cl-color-secondary it-ok" (click)="dialog.closeAll()">
            <span>Close</span>
          </button>
        </span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #warningPairs let-warning>
  @if (hasKeys(warning.details, 'problematic_pairs') && warning.details.problematic_pairs?.length >= 0) {
    <div class="basic-qc-title">{{ warning.message }}</div>
    <div class="basic-qc-pairs">
      @for (pair of warning.details.problematic_pairs.slice(0, 5); track $index) {
        <div class="basic-qc-pair-group">
          @for (cap of pair; track $index) {
            @if (hasKeys(cap, 'start', 'end', 'text')) {
              <div class="basic-qc-pair-row">
                <code class="basic-qc-ts">{{ cap.start }}</code>–<code class="basic-qc-ts">{{ cap.end }}</code>
                <span class="basic-qc-pair-text">"{{ cap.text }}"</span>
              </div>
            } @else {
              <pre class="basic-qc-unknown">{{ cap | json }}</pre>
            }
          }
        </div>
      }
      @if (warning.details.problematic_pairs.length > 5) {
        <div class="basic-qc-detail">… and {{ warning.details.problematic_pairs.length - 5 }} more</div>
      }
    </div>
  } @else {
    <pre class="basic-qc-unknown">{{ warning | json }}</pre>
  }
</ng-template>

<ng-template #warningItem let-warning>
  @switch (warning.code) {

    @case ('SUBS_EMPTY_SOURCE') {
      <div class="basic-qc-title">{{ warning.message }}</div>
    }

    @case ('SUBS_CANNOT_READ_SOURCE') {
      <div class="basic-qc-title">{{ warning.message }}</div>
      @if (hasKeys(warning.details, 'error')) {
        <div class="basic-qc-detail"><code>{{ warning.details.error }}</code></div>
      } @else if (warning.details) {
        <pre class="basic-qc-unknown">{{ warning.details | json }}</pre>
      }
    }

    @case ('SUBS_UNSUPPORTED_FORMAT') {
      <div class="basic-qc-title">{{ warning.message }}</div>
    }

    @case ('SUBS_NO_CAPTIONS') {
      @if (hasKeys(warning.details, 'language')) {
        <div class="basic-qc-title">{{ warning.message }}</div>
      } @else {
        <pre class="basic-qc-unknown">{{ warning | json }}</pre>
      }
    }

    @case ('SUBS_FIRST_TIMESTAMP_HIGH') {
      @if (hasKeys(warning.details?.first_subtitle, 'start', 'end', 'text')) {
        <div class="basic-qc-title">{{ warning.message }}</div>
        <div class="basic-qc-detail">
          Starts at <code>{{ warning.details.first_subtitle.start }}</code>
          &nbsp;·&nbsp; "{{ warning.details.first_subtitle.text }}"
        </div>
      } @else {
        <pre class="basic-qc-unknown">{{ warning | json }}</pre>
      }
    }

    @case ('SUBS_OVERLAPPING_DIFF_END_TIME') {
      <ng-container [ngTemplateOutlet]="warningPairs" [ngTemplateOutletContext]="{ $implicit: warning }"></ng-container>
    }

    @case ('SUBS_OVERLAPPING_TIME_RANGES') {
      <ng-container [ngTemplateOutlet]="warningPairs" [ngTemplateOutletContext]="{ $implicit: warning }"></ng-container>
    }

    @case ('SUBS_GAP_TOO_SHORT') {
      <ng-container [ngTemplateOutlet]="warningPairs" [ngTemplateOutletContext]="{ $implicit: warning }"></ng-container>
    }

    @case ('SUBS_EVENT_DURATION_TOO_SHORT') {
      @if (hasKeys(warning.details, 'start', 'end', 'text')) {
        <div class="basic-qc-title">{{ warning.message }}</div>
        <div class="basic-qc-detail">
          <code>{{ warning.details.start }}</code>–<code>{{ warning.details.end }}</code>
          &nbsp;"{{ warning.details.text }}"
        </div>
      } @else {
        <pre class="basic-qc-unknown">{{ warning | json }}</pre>
      }
    }

    @case ('SUBS_MISSING_FONT') {
      @if (hasKeys(warning.details, 'language')) {
        <div class="basic-qc-title">{{ warning.message }}</div>
      } @else {
        <pre class="basic-qc-unknown">{{ warning | json }}</pre>
      }
    }

    @case ('SUBS_MISSING_GLYPHS') {
      @if (hasKeys(warning.details, 'affected_glyphs')) {
        <div class="basic-qc-title">{{ warning.message }}</div>
        <div class="basic-qc-glyphs">
          @for (g of warning.details.affected_glyphs; track $index) {
            @if (hasKeys(g, 'glyph', 'timestamps')) {
              <div class="basic-qc-glyph-row">
                <code class="basic-qc-glyph-char">{{ formatGlyph(g.glyph) }}</code>
                <span class="basic-qc-detail">
                  first at <code>{{ g.timestamps[0] }}</code>
                  @if (g.timestamps.length === 2) { · 1 more occurrence }
                  @if (g.timestamps.length > 2) { · {{ g.timestamps.length - 1 }} more occurrences }
                </span>
              </div>
            } @else {
              <pre class="basic-qc-unknown">{{ g | json }}</pre>
            }
          }
        </div>
      } @else {
        <pre class="basic-qc-unknown">{{ warning | json }}</pre>
      }
    }

    @default {
      <pre class="basic-qc-unknown">{{ warning | json }}</pre>
    }
  }
</ng-template>

<app-logo-area [breadcrumbs]="breadcrumps()"></app-logo-area>
<main>
  <app-headline-section [title]="file()?.name ?? ''"></app-headline-section>
  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <app-s3-link [fof]="file()"></app-s3-link>
        </div>
      </div>
    </div>

  </section>
  <section class="cl-section cl-section-regular">
    <div class="container">
      @if (loading()) {
        <div class="row">
          <div class="col-12" style="text-align: center;">
            @if (loadError()) {
              <p role="alert">Could not load the file details: {{ loadError() }}</p>
            } @else {
              <div class="cl-spinner">Loading File Details ...<i class="fas fa-spinner fa-spin"></i></div>
            }
          </div>
        </div>
      }
      @if (!loading()) {
        <div class="row">
          <div class="col-12" style="  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end; ">
            <div class="cl-h3">
              Tracks
            </div>
            <div style="display: flex; flex-direction: row; gap: 16px;  align-items: end; ">
              <app-message-field #trackUpdateMessage/>
              @if (canUpdateFile()) {
                <div
                >
                  <app-do-button buttonClass="btn btn-sm cl-color-secondary" [messageField]="trackUpdateMessage" (actionTriggered)="refreshTracks($event)">
                    <span>Reset Tracks</span>
                  </app-do-button>
                </div>
              }
            </div>
          </div>
          <div class="col-12">
            <form role="form" class="castlabs-ui" #form="ngForm">
              <div class="cl-table-scroll">
                <table class="cl-table-data">
                  <thead>
                  <tr>
                    <th class="cl-table-head">index</th>
                    <th class="cl-table-head">track&nbsp;type</th>
                    <th class="cl-table-head">language</th>
                    <th class="cl-table-head cl-th-checkbox">enabled</th>
                  </tr>
                  </thead>
                  <tbody>
                    @if (tracks.length === 0) {
                      <tr class="cl-tr-no-data">
                        <td colspan="100">No data available.</td>
                      </tr>
                    }
                    @for (track of tracks; track track; let i = $index) {
                      <tr>
                        <td>
                          <div [style.color]="track['enabled']?'unset':'var(--cl-color-text-faded)'">{{ track['index'] }}
                          </div>
                        </td>
                        <td>
                          @if (track['track_type'] == TRACKTYPES.Audio || track['track_type'] == TRACKTYPES.Video || track['track_type'] == TRACKTYPES.Image ||
                          track['track_type'] == TRACKTYPES.Data || !canUpdateFile()) {
                            <div [style.color]="track['enabled']?'unset':'var(--cl-color-text-faded)'"
                                 style="width: 100%; overflow: visible"> {{ track['track_type'] }}
                            </div>
                          } @else {
                            <div class="cl-form">
                              @if (track['track_type'] == TRACKTYPES.Subtitle || track['track_type'] == TRACKTYPES.Closedcaption) {
                                <select class="form-select" name="track_type{{i}}" [(ngModel)]="track['track_type']"
                                        [disabled]="!track['enabled']"
                                >
                                  @for (tt of [TRACKTYPES.Subtitle, TRACKTYPES.Closedcaption]; track tt) {
                                    <option [value]="tt">
                                      {{ tt }}
                                    </option>
                                  }
                                </select>
                              }
                            </div>
                          }
                        </td>
                        <td>
                          @if (!canUpdateFile()) {
                            <div [style.color]="track['enabled']?'unset':'var(--cl-color-text-faded)'"
                            ><app-language [code]="track['language']" [named]="true" [trackType]="track['track_type']"/></div>
                          } @else {
                            <div style="" class="cl-form">
                              <select
                                [(ngModel)]="track['language']"
                                name="language{{i}}"
                                [disabled]="!track['enabled']"
                                class="form-select">
                                @for (lang of languages; track lang) {
                                  <option [value]="lang.id">
                                    {{ lang.name }}
                                  </option>
                                }
                              </select>
                            </div>
                          }
                        </td>
                        <td class="cl-td-checkbox">
                          <div class="form-check" style="margin-top: 0">
                            <input type="checkbox" class="form-check-input" title="{{ track['index'] }} enabled"
                                   [(ngModel)]="track['enabled']" name="enabled{{i}}"
                                   [disabled]="!canUpdateFile()">
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </form>
          </div>
          <div class="col-12">
            <h3>Tags</h3>
          </div>
          <div class="col-12">
            <table
              class="cl-table-data cl-form">
              <thead>
              <tr>
                <th class="cl-table-head">key</th>
                <th class="cl-table-head">value</th>
              </tr>
              </thead>
              <tbody>
                @if (!tags || tags.length === 0) {
                  <tr class="cl-tr-no-data">
                    <td colspan="100">
                      No tags available.
                      @if (canUpdateFile()) {
                        <a role="button"
                           class="cl-a-quickaction"
                           (click)="onAddTag($event)">
                          Add tag
                        </a>
                      }
                    </td>
                  </tr>
                }
                @for (tag of tags; track tag; let i = $index; let last = $last; let first = $first) {
                  <tr>
                    <td>
                      @if (canUpdateFile()) {
                        <input
                          type="text" [(ngModel)]="tags[i].key">
                      } @else {
                        {{ tags[i].key }}
                      }
                    </td>
                    <td>
                      @if (canUpdateFile()) {
                        <div style="display: flex; flex-direction: row"
                        >
                          <input type="text" [(ngModel)]="tags[i].value">
                          @if (last) {<div style="margin-left: -80px ; padding-top: 7px; width: 80px">
                            <a role="button" class="cl-a-quickaction" style="white-space:nowrap;"
                               (click)="onAddTag($event)">
                              Add&nbsp;tag
                            </a>
                          </div>}
                        </div>
                      } @else {
                        {{ tags[i].value }}
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          @if (canUpdateFile()) {
            <div class="col-12">
              <app-form-footer label="Save tags & tracks" icon="save" (action)="save($event)"></app-form-footer>
            </div>
          }
          <div class="cl-h3">System-Generated Metadata</div>
          <div class="col-12" style="display: flex; flex-direction: row">
            <div style="flex-direction: row; display: flex; justify-content:  space-between; gap: 16px">
              <div>
                <button (click)="openDialog(modalFFProbeJSON)" class="btn btn-sm cl-color-secondary">Show FFProbe JSON
                </button>
              </div>
              <div>
                <button (click)="openDialog(modalMediaInfo)" class="btn btn-sm cl-color-secondary">Show MediaInfo JSON
                </button>
              </div>
              <button (click)="openDialog(modalMediaInfoTxt)" class="btn btn-sm cl-color-secondary">Show MediaInfo text
              </button>
            </div>
          </div>
          <div class="cl-h3">QC and extra information</div>
          <div class="col-12">
            <div style="margin-bottom: 12px">
              <button (click)="openDialog(modalExtraInfo)" class="btn btn-sm cl-color-secondary">Show extra info</button>
            </div>
            <div>
              <div class="basic-qc-header">
                <strong>Auto QC</strong>
                @if (canRefreshBasicQc()) {
                  <app-do-button #basicQcRefreshBtn [messageField]="basicqc_message" buttonClass="cl-btn-quickaction it-cancel"
                    (actionTriggered)="refresh_basic_qc($event)">
                    @if (basicQcRefreshBtn._processing) {
                      <i class="fas fa-spinner fa-spin" style="font-size: 0.75em; margin-right: 4px"></i>
                    }
                    <span>Refresh</span>
                  </app-do-button>
                }
                @if (warnings().length > 0) {
                  <app-do-button [messageField]="basicqc_message" buttonClass="btn cl-btn-icon cl-color-tertiary it-cancel"
                    (actionTriggered)="copy_warnings($event)">
                    <i class="fas fa-copy" aria-hidden="true"></i>
                    <span class="sr-only">Copy QC warnings</span>
                  </app-do-button>
                }
                <app-message-field #basicqc_message/>
              </div>
              @if (visibleWarnings().length === 0) {
                <span class="basic-qc-ok"><i class="fas fa-check-circle"></i> No QC issues found.</span>
              }
              @if (criticalWarnings().length > 0) {
                <div class="basic-qc-section-label basic-qc-section-label--critical">
                  <i class="fas fa-exclamation-circle"></i>
                  CRITICAL ERRORS
                  <span class="basic-qc-section-sub">(Fix required to encode)</span>
                </div>
                @for (warning of criticalWarnings(); track $index) {
                  <div class="basic-qc-critical">
                    <ng-container [ngTemplateOutlet]="warningItem" [ngTemplateOutletContext]="{ $implicit: warning }"></ng-container>
                  </div>
                }
              }
              @if (criticalWarnings().length > 0 && groupedNonCriticalWarnings().length > 0) {
                <div class="basic-qc-divider"></div>
              }
              @if (groupedNonCriticalWarnings().length > 0) {
                <div class="basic-qc-section-label basic-qc-section-label--warning">
                  <i class="fas fa-exclamation-triangle"></i>
                  WARNINGS
                  <span class="basic-qc-section-sub">(Review recommended)</span>
                </div>
                @for (group of groupedNonCriticalWarnings(); track group.code) {
                  <div class="basic-qc-warning">
                    @if (group.items.length === 1) {
                      <ng-container [ngTemplateOutlet]="warningItem" [ngTemplateOutletContext]="{ $implicit: group.items[0] }"></ng-container>
                    } @else {
                      <div class="basic-qc-consolidated">
                        <div class="basic-qc-title">{{ group.items[0].message }}</div>
                        <span class="basic-qc-count-badge">{{ group.items.length }} occurrences</span>
                      </div>
                      <a role="button" class="cl-a-quickaction basic-qc-view-all"
                         (click)="openWarningOccurrences(group.items, modalWarningOccurrences)">
                        View all {{ group.items.length }} occurrences
                      </a>
                    }
                  </div>
                }
              }
            </div>
          </div>
          @if (has_video) {
            <div class="cl-h3">Stills</div>
            @if ((this.stills); as stills) {
              @if (stills.length > 0) {
                <ngx-gallery [options]="galleryOptions" [images]="stills" class="ngx-gallery"></ngx-gallery>
              } @else {
                <div style="display: flex; flex-direction: row;align-items: center">
                  <div style="flex-grow: 1; display: flex; flex-direction: column; align-self: center">
                    <div style="text-align: center">
                      <img width="125" src="../../../../assets/emptystates/NoImages.png"/>
                    </div>
                    <div class="cl-h3" style="text-align: center">There are no stills.</div>
                  </div>
                  <div style="align-self: flex-end">
                    <app-do-button (actionTriggered)="generate_stills($event)">
                      <span>Generate Stills</span>
                    </app-do-button>
                  </div>
                </div>
              }
            }
          }
        </div>
      }
    </div>
  </section>
</main>
